module.exports = {
  "salesModalTemplatesInteraction": {
    "namespace": "templates",
    "name": "Interaction",
    "class": "interaction",
    "properties": {
      "action": "string"
    }
  },
  "salesModalDocumentsInteraction": {
    "namespace": "documents",
    "name": "Interaction",
    "class": "interaction",
    "properties": {
      "action": "string"
    }
  }
};